/**
 * OpenSeaMap seamark-overlay setting: a single on/off toggle, kept on the device
 * in localStorage. Mirrors the satellite store's persistence pattern. The overlay
 * is online-only (live tiles), so there's nothing else to remember here.
 */
import { create } from 'zustand';

const ON_LS = 'acp.seamark.on.v1';

function loadEnabled(): boolean {
  try {
    return (typeof localStorage !== 'undefined' ? localStorage.getItem(ON_LS) : null) === '1';
  } catch {
    return false;
  }
}
function save(v: boolean): void {
  try {
    if (typeof localStorage !== 'undefined') localStorage.setItem(ON_LS, v ? '1' : '0');
  } catch {
    /* ignore quota / private mode */
  }
}

interface SeamarkState {
  /** The OpenSeaMap seamark OVERLAY toggle. On = marks stream over the current base. */
  enabled: boolean;
  setEnabled: (b: boolean) => void;
}

export const useSeamarkStore = create<SeamarkState>((set) => ({
  enabled: loadEnabled(),
  setEnabled: (enabled) => {
    save(enabled);
    set({ enabled });
  },
}));
